export default __webpack_public_path__ + "static/media/VICTORIA.d21d7d07.png";